// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".worksheets-renderer-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n", "",{"version":3,"sources":["webpack://src/modules/accounting_statement_app/components/WorksheetsRenderer/WorksheetsRenderer.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB","sourcesContent":[".worksheets-renderer-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
